import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-notice",
  "use": "icon-notice-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-notice\"><defs><style type=\"text/css\"></style></defs><path d=\"M 920 737.7 h -78.36 V 488.22 c 0 -183 -114.38 -335 -265.88 -369 v -1.14 a 64 64 0 1 0 -128 0 v 1.14 c -151.5 34 -265.88 186 -265.88 369 V 737.7 H 104 a 40 40 0 0 0 0 80 h 248.19 a 160 160 0 0 0 319.62 0 H 920 a 40 40 0 0 0 0 -80 Z M 512 889.92 a 80 80 0 0 1 -79.62 -72.22 h 159.24 A 80 80 0 0 1 512 889.92 Z M 761.64 737.7 H 262 V 488.13 C 262 327.31 373.81 197 511.79 197 s 249.85 130.31 249.85 291.13 Z\" p-id=\"95361\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/notice.svg
// module id = MqGM
// module chunks = 22